import { switchCalendarViewText } from './CalendarAssetCommandDescriptors.locstring.json';
import type { AssetCommandDescriptor } from 'owa-timestream-asset-sdk';
import { ControlIcons } from 'owa-control-icons';

export const switchCalendarView: AssetCommandDescriptor = {
    id: 'switchCalendarView',
    iconName: ControlIcons.Calendar,
    titleResourceId: switchCalendarViewText,
};
